import * as React from "react";
const SvgIcFolder = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M1 2H11L13 5H23V22H1V5V2ZM20 19H4V8H20V19Z" fill="currentColor" /></svg>;
export default SvgIcFolder;